import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import "./App.css";
import "./landing.css";

import TopNavbar from "./components/common/TopNavbar.js";
import NotFound from "./NotFound.js";
import Home from "./Home.js";

export default function App() {
  return (
    <Router>
      <div className="site App">
        <TopNavbar />
        <Routes>
          <Route path="/notfound" element={<NotFound />} />
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Router>
  );
}
